import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import "../assets/css/calendario.css";
import Layout from "./Layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPenToSquare,
    faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";

moment.locale("es");

const EventsCalendar = () => {
    const isFutureDay = (day) => {
        const today = moment().startOf("day");
        const currentDate = moment([selectedYear, selectedMonth, day]);
        return currentDate.isAfter(today);
    };

    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [selectedMonth, setSelectedMonth] = useState(moment().month());
    const [dayStatuses, setDayStatuses] = useState({});
    const [tempDayStatuses, setTempDayStatuses] = useState({});
    const [showMarkDays, setShowMarkDays] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [showOptionModal, setShowOptionModal] = useState(false);

    const navigate = useNavigate();
    const currentYear = moment().year();
    const years = Array.from({ length: 6 }, (_, i) => currentYear + i);
    const monthNames = moment.months();

    const handleYearChange = (e) => setSelectedYear(Number(e.target.value));
    const handleMonthChange = (e) => setSelectedMonth(Number(e.target.value));
    const toggleMarkDays = () => {
        setShowMarkDays((prev) => !prev);
        if (!showMarkDays) {
            setTempDayStatuses({ ...dayStatuses });
        }
    };

    const daysInMonth = moment([selectedYear, selectedMonth]).daysInMonth();
    const firstDayOfWeek = moment([selectedYear, selectedMonth])
        .startOf("month")
        .day();

    const handleDayClick = (day) => {
        const date = moment([selectedYear, selectedMonth, day]).format(
            "YYYY-MM-DD"
        );
        if (!showMarkDays) {
            setSelectedDate(date);
            setShowOptionModal(true);
        } else {
            setTempDayStatuses((prev) => ({
                ...prev,
                [date]: prev[date] === "Managed" ? "Pending" : "Managed",
            }));
        }
    };

    const redirectToReport = (reportType) => {
        localStorage.setItem("date", selectedDate);
        if (reportType === "general") {
            navigate("/reporte-general/" + selectedDate);
        } else if (reportType === "productos") {
            navigate("/reporte-productos/" + selectedDate);
        }
        closeOptionModal();
    };

    const clearStatuses = () => setTempDayStatuses({});
    const cancelChanges = () => {
        setTempDayStatuses({});
        setShowMarkDays(false);
    };

    const saveChanges = () => {
        setDayStatuses({ ...tempDayStatuses });
        setShowMarkDays(false);
        alert("Changes saved successfully.");
    };

    const closeOptionModal = () => setShowOptionModal(false);

    const monthName = moment([selectedYear, selectedMonth]).format("MMMM YYYY");

    return (
        <Layout>
            <div>
                <div className="content-container" style={{ display: "" }}>
                    <div className="bigCalendar-container">
                        <div className="titulo-calendario">
                            <label>Segmentation History - Customer Search Terms</label>
                        </div>

                        <div className="selectors-container">
                            <div className="selector-group">
                                <label>Select a year:</label>
                                <select value={selectedYear} onChange={handleYearChange}>
                                    {years.map((year) => (
                                        <option key={year} value={year}>
                                            {year}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="selector-group">
                                <label>Select a month:</label>
                                <select value={selectedMonth} onChange={handleMonthChange}>
                                    {monthNames.map((month, index) => (
                                        <option key={index} value={index}>
                                            {month}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <h2 className="month-title">{monthName}</h2>

                        <div className="calendar-grid">
                            {[
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday",
                                "Sunday",
                            ].map((dayName) => (
                                <div key={dayName} className="calendar-header">
                                    {dayName}
                                </div>
                            ))}

                            {[
                                ...Array(firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1).fill(null),
                                ...Array(daysInMonth).keys(),
                            ].map((day, index) =>
                                day === null ? (
                                    <div key={index} className="calendar-cell empty" />
                                ) : (
                                    <div
                                        key={index}
                                        className={`calendar-cell ${isFutureDay(day + 1) ? "future-day" : ""} ${(showMarkDays ? tempDayStatuses : dayStatuses)[
                                            moment([selectedYear, selectedMonth, day + 1]).format(
                                                "YYYY-MM-DD"
                                            )
                                            ] || ""
                                            }`}
                                        onClick={() =>
                                            !isFutureDay(day + 1) && handleDayClick(day + 1)
                                        }
                                    >
                                        {day + 1}
                                        {(showMarkDays ? tempDayStatuses : dayStatuses)[
                                            moment([selectedYear, selectedMonth, day + 1]).format(
                                                "YYYY-MM-DD"
                                            )
                                        ] === "Pending" && (
                                                <FontAwesomeIcon
                                                    icon={faPenToSquare}
                                                    style={{ color: "red" }}
                                                    className="ms-2"
                                                />
                                            )}
                                        {(showMarkDays ? tempDayStatuses : dayStatuses)[
                                            moment([selectedYear, selectedMonth, day + 1]).format(
                                                "YYYY-MM-DD"
                                            )
                                        ] === "Managed" && (
                                                <FontAwesomeIcon
                                                    icon={faCircleCheck}
                                                    style={{ color: "green" }}
                                                    className="ms-2"
                                                />
                                            )}
                                    </div>
                                )
                            )}
                        </div>

                        {showMarkDays && (
                            <div className="actions-container">
                                <button onClick={clearStatuses} className="btn-clear">
                                    Clear
                                </button>
                                <button onClick={cancelChanges} className="btn-cancel">
                                    Cancel
                                </button>
                                <button onClick={saveChanges} className="btn-save">
                                    Save
                                </button>
                            </div>
                        )}

                        <div className="row mt-4">
                            <div className="col-6 d-flex justify-content-center">
                                <button className="btn btn-primary" onClick={toggleMarkDays}>
                                    {showMarkDays ? "Hide days" : "Mark days"}
                                </button>
                            </div>
                            <div className="col-6 d-flex justify-content-center">
                                <div className="status-container">
                                    <div className="status-item">
                                        <FontAwesomeIcon
                                            icon={faPenToSquare}
                                            style={{ color: "red", fontSize: "1.3rem" }}
                                        />
                                        <h4>Pending</h4>
                                    </div>
                                    <div className="status-item">
                                        <FontAwesomeIcon
                                            icon={faCircleCheck}
                                            style={{ color: "green", fontSize: "1.3rem" }}
                                        />
                                        <h4>Managed</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {showOptionModal && (
                    <div className="modal">
                        <div className="container bg-light w-50 mx-auto">
                            <div className="row">
                                <div className="col-12">
                                    <p className="fs-4 text-center my-3">What would you like to do for {selectedDate}</p>
                                </div>
                                <div className="col-12 text-center">
                                    <button className="btn btn-primary mb-3" onClick={() => redirectToReport("general")}>
                                        General Report{" "}
                                    </button>
                                </div>
                                <div className="col-12 text-center">
                                    <button className="btn btn-danger mb-3" onClick={closeOptionModal}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default EventsCalendar;